<template>
  <div
    class="h-[51px] cursor-pointer select-none overflow-hidden border-t border-[--v3-theme-primarydarkercolor] bg-[--v3-theme-primarycolor] text-[--v3-theme-primarytextcolor] transition-all duration-150 hover:bg-[--v3-theme-primarydarkercolor]"
    :class="{
      'w-0': collapsed,
      'w-[227px]': !collapsed
    }"
    @click="showProfilePanel = !showProfilePanel"
  >
    <div
      ref="userProfileNav"
      class="avatar mx-[15px] flex h-full w-[197px] items-center justify-between gap-x-4 transition-all duration-150"
    >
      <div class="flex flex-1 items-center gap-[10px]">
        <Avatar
          :image="avatar"
          class="size-[32px] scale-100 transition-all duration-150"
          :class="{
            'scale-0': collapsed
          }"
          style="background-color: #ece9fc; color: #2a1261;"
          shape="circle"
        />
        <Skeleton v-if="isLoading" />
        <span
          v-else
          class="truncate font-normal leading-[21px] transition-all duration-150"
          :class="{
            'text-[0]': collapsed,
            'text-[14px]': !collapsed
          }"
        >
          {{ name ?? 'Connect your shop' }}
        </span>
      </div>
      <div class="flex size-[12px] items-center justify-center text-[--v3-blue-gray-bluegray-400]">
        <Icon :name="(showProfilePanel)? `angle-down`: `angle-up`" />
      </div>
    </div>
  </div>
  <Transition>
    <div
      v-show="!collapsed"
      v-if="showProfilePanel"
      ref="floatingProfilePanel"
      class="floatingPanel z-[110]"
      :style="floatingStyles"
    >
      <slot />
    </div>
  </Transition>
</template>

<script setup lang='ts'>
import { autoUpdate, offset, useFloating } from '@floating-ui/vue';
import Avatar from 'primevue/avatar';
import Skeleton from 'primevue/skeleton';
import { ref } from 'vue';

import Icon from '@/common/components/atoms/Icon';

withDefaults(defineProps<{
  avatar?: string
  collapsed?: boolean
  isLoading?: boolean
  name: string,
}>(), {
  avatar: "/img/avatar.png",
  collapsed: false,
  isLoading: false,
});

const userProfileNav = ref(null);
const floatingProfilePanel = ref(null);
const showProfilePanel = ref(false);
const { floatingStyles } = useFloating(userProfileNav, floatingProfilePanel, {
  placement: 'top-start',
  whileElementsMounted: autoUpdate,
  middleware: [offset(8)],
});
</script>

<style scoped>
.name {
  font-family: Roboto;
}

.floatingPanel {
  transition: opacity 150ms,
              margin-top 150ms;
}

.v-enter-from,
.v-leave-to
{
  opacity: 0;
  margin-top: 15px;
}

.v-enter-to,
.v-leave-from
{
  opacity: 1;
  margin-top: 0;
}
</style>
